import React from 'react';
import './login.css'
import pic1 from '../assets/pic1.png'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Inputtext from '../components/common/input';
import Cta from '../components/common/cta';
import pic6 from '../assets/pic6.png'
import pic7 from '../assets/pic7.png'
import pic8 from '../assets/pic8.png'
import { useNavigate } from 'react-router-dom';
import Preloader from '../components/common/preloader';
import Errormsginput from '../components/common/errormsginput';



const Login = () => {
    
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);





const navigate = useNavigate();



                  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />



    const handleLogin = (e) => {
        e.preventDefault();

        let hasError = false;
        if (!email) {
            setEmailError("Email is required");
            hasError = true;} 

        else if (!/\S+@\S+\.\S+/.test(email)) {
            setEmailError("Invalid email format");
            hasError = true;} else { setEmailError(""); }


   if (!password) { setPasswordError("Password is required"); hasError = true; }
         else if (password.length < 8) { setPasswordError("At least 8 characters"); hasError = true; }
    else setPasswordError("");
          if (hasError) return;

        navigate('/home'); };


    return ( 
        <>
        <main className='login-background'>
                <section className='main-sec-login'>
                        <section className='top-sec-login'>
                            <img className='logologin' src={pic1} alt='logo'></img>
                        </section>
                        <form className='container-login-card' onSubmit={handleLogin}>
                            <fieldset className='login-card'>
                                    <fieldset className='sub-cont-login'>
                                        <h1 className='loginheader'>{content?.[22]?.header}</h1>


                                        <fieldset className='container-login--inputs-and-cta'>
                                        <fieldset className='container-inputss'>
                                            <Inputtext id='email'  label='Email Address' placeholder='Enter your email address'
                                              value={email}
                                            onChange={(e) => setEmail(e.target.value)}/>
                                                <Errormsginput message={emailError} />

                                            <fieldset className='container-forgot-password'>
                                                <Inputtext 
                                                id="password"
                                                label="Password"
                                                type="password"
                                                placeholder="Enter your password"
                                                value={password}
                                                    onChange={(e) => setPassword(e.target.value)} />
                                                <Errormsginput message={passwordError} />
                                              

                                                <h2 className='forgotpasswordd-text'>Forgot password?</h2>
                                            </fieldset>


                                            <label className="custom-checkbox">
                                                            <input type="checkbox" />
                                                            <span className="checkmark"></span>
                                                            Remember me
                                             </label>
                                        </fieldset>

                                                    <Cta title={content?.[22]?.cta}   />


                                                    <fieldset className='container-login-with'>
                                                        <fieldset className='loginwith-container'>
                                                            <div className='line-login'></div>
                                                            <h2 className='loginwith-text'>Log in with</h2>
                                                            <div className='line-login'></div>
                                                        </fieldset>

                                                        <fieldset className='icons-container-login'>
                                                                <img src={pic6} alt='google'></img>
                                                                <img src={pic7} alt='facebook'></img>
                                                                <img src={pic8} alt='x'></img>

                                                        </fieldset>
                                                    </fieldset>


                                                    <fieldset className='signup-containerr'>
                                                            <h2 className='signup-text1'>Don’t have an account?</h2>
                                                            
                                                            <h2 className='signup-text' onClick={() => navigate('/signup')} >Sign up</h2>
                                                       
                                                    </fieldset>



                                        </fieldset>




                                    </fieldset>
                            </fieldset>
                        </form>
                </section>
        </main>
        </>
     );
}
 
export default Login;